export default __webpack_public_path__ + "static/media/microbe2.722315fe.png";